import { BaseQueryApi, BaseQueryFn, FetchArgs, FetchBaseQueryError, FetchBaseQueryMeta } from "@reduxjs/toolkit/dist/query";

import { RTKErrorType, LoginErrorResponse } from "../types/apiResponses";

type BaseQuery = BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta>

export function baseQueryWithAuthCheck(baseQuery: BaseQuery) {
  return async (args: any, api: BaseQueryApi, extraOptions: any) => {
    let result = await baseQuery(args, api, extraOptions);
    if (result.error) {
      if (result.error.status === 401) {
        const url = window.location.href;
        const loginUrl = (result.error as RTKErrorType<LoginErrorResponse>)?.data?.info?.redirect?.log_in_url;
        const redirectUrl = loginUrl + "?prevUrl=" + encodeURIComponent(url);
        window.location.href = redirectUrl; // redirect login page
      }
    }
    return result;
  }
}